import { render, staticRenderFns } from "./vivaWantingListByadmin.vue?vue&type=template&id=2337dc3e&scoped=true&"
import script from "./vivaWantingListByadmin.vue?vue&type=script&lang=js&"
export * from "./vivaWantingListByadmin.vue?vue&type=script&lang=js&"
import style0 from "./vivaWantingListByadmin.vue?vue&type=style&index=0&id=2337dc3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337dc3e",
  null
  
)

export default component.exports